import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import { Text, StyledCard, StyledCardContent } from '../../index';

export const ShareLinkCard = ({ url }) => {
    return (
        <StyledCard>
            <StyledCardContent>
                <Text $fontSize="20px" $bold>
                    Link Sharing
                </Text>
                <Text $fontSize="14px">Open Session Link:</Text>
                <div
                    style={{
                        width: '100%',
                        height: '32px',
                        position: 'relative',
                        backgroundColor: '#F2F2F2',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 25px',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        marginTop: '5px',
                    }}
                >
                    <Text $fontSize="16px" style={{ color: '#9E9E9E' }}>
                        {url}
                    </Text>
                    <Button
                        style={{
                            backgroundColor: '#838181',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 20px 0 15px',
                            borderRadius: '0',
                        }}
                        onClick={() => navigator.clipboard.writeText(url)}
                    >
                        <Text $color="white" $fontSize="14px" style={{ textTransform: 'none' }}>
                            Copy Link
                        </Text>
                    </Button>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

ShareLinkCard.propTypes = {
    url: PropTypes.string.isRequired,
};
